import { Grid, TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { studentInsUpdSlice, selectStudentInsUpd } from "../../../redux/student/studentInsUpdSlice";
import { useAppDispatch } from "../../../app/hooks";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { brtToIso, isoToBrt } from "../../../redux/common";

export function StudentInsUpdData() {
    const studentInsUpd = useSelector(selectStudentInsUpd);
    const dispatch = useAppDispatch();

    const changed = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const student = {
            ...studentInsUpd.student
        };
        switch (event.target.id) {
            case "name":
                student.name = event.target.value;
                break;
            case "nickname":
                student.nickname = event.target.value;
                break;
            case "email":
                student.email = event.target.value;
                break;
            case "birthDate":
                student.birthDate = brtToIso(event.target.value);
                break;
            case "schoolNumber":
                student.schoolNumber = event.target.value;
                break;
            default:
                console.error("Invalid field id: " + event.target.id);
                return;
        }
        dispatch(studentInsUpdSlice.actions.set(student));
    };

    return <>
        <Typography variant="h6" gutterBottom>
            Dados do aluno
        </Typography>
        <Grid container spacing={3}>
            <Grid size={12}>
                <TextField required id="name" name="name" label="Nome"
                        fullWidth autoComplete="nome" variant="standard"
                        value={studentInsUpd.student.name}
                        onChange={changed} />
            </Grid>
            <Grid size={12}>
                <TextField id="nickname" name="nickname" label="Apelido"
                    fullWidth autoComplete="apelido" variant="standard"
                    value={studentInsUpd.student.nickname}
                    onChange={changed} />
            </Grid>
            <Grid size={6}>
                <DatePicker
                    label="Data de Nascimento"
                    value={dayjs(isoToBrt(studentInsUpd.student.birthDate), "DD/MM/YYYY")}
                    onChange={(newValue) => {
                        console.debug("changed student birth date", newValue ? newValue.format("DD/MM/YYYY") : "");
                        const student = {
                            ...studentInsUpd.student
                        };
                        student.birthDate = brtToIso(newValue ? newValue.format("DD/MM/YYYY") : undefined);
                        dispatch(studentInsUpdSlice.actions.set(student));
                    }}
                    format="DD/MM/YYYY"
                    slotProps={{ textField: { size: "small", sx: {  } } }}
                />
            </Grid>
            <Grid size={6}>
                <TextField id="schoolNumber" name="schoolNumber" label="Matricula"
                    fullWidth autoComplete="matricula" variant="standard"
                    value={studentInsUpd.student.schoolNumber}
                    onChange={changed} />
            </Grid>
            <Grid size={12}>
                <TextField id="email" name="email" label="e-mail"
                    fullWidth autoComplete="e-mail" variant="standard"
                    value={studentInsUpd.student.email}
                    onChange={changed} />
            </Grid>
        </Grid>
    </>;
}
